import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { SubHeader } from './SubHeader';
import './AccountDetail.less';
import { useAppSelector } from '@monorepo/shared';
import { selectDebugKey } from '@monorepo/shared/store/authSlice';

export const Account = () => {
  const { accountId } = useParams();
  const debugKey = useAppSelector(selectDebugKey);
  const navigate = useNavigate();
  if (!accountId) {
    navigate(`/cred/ou`, {
      state: {
        debug_key: debugKey
      }
    });
  }
  return (
    <div className="account-container">
      <SubHeader />
      <div className="content">
        <Outlet />
      </div>
    </div>
  );
};
